import { BatteryTypeRef } from '@/dto/scenario/battery/BatteryReference';
import { ScenarioBattery } from '@/dto/scenario/battery/ScenarioBattery';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class ScenarioBatteryExt extends DtoExt {

  public static fromDto(dto: ScenarioBattery): ScenarioBatteryExt {
    return new ScenarioBatteryExt({
      typeRef: dto.typeRef,
      isGridForming: dto.isGridForming,
      cRate: dto.cRate,
      socMinPercentage: dto.socMinPercentage,
      globalSocMaxPercentage: dto.globalSocMaxPercentage,
      isRechargeableByGrid: dto.isRechargeableByGrid,
      isRechargeableByGenerator: dto.isRechargeableByGenerator,
      socMaxChargeGrid: dto.socMaxChargeGrid,
      socMaxChargeGen: dto.socMaxChargeGen,
      socToleranceGridForming: dto.socToleranceGridForming,
      chargeEfficiencyPercentage: dto.chargeEfficiencyPercentage,
      dischargeEfficiencyPercentage: dto.dischargeEfficiencyPercentage,
      lifetimeCycles: dto.lifetimeCycles,
      invertersLifetimeYear: dto.invertersLifetimeYear,
      fromHour: dto.fromHour,
      toHour: dto.toHour
    });
  }

  public socMinPercentage: number | null = null;
  public globalSocMaxPercentage: number | null = null;

  public isRechargeableByGrid: boolean | null = null;
  public socMaxChargeGrid: number | null = null;

  public isRechargeableByGenerator: boolean | null = null;
  public socMaxChargeGen: number | null = null;
  public socToleranceGridForming: number | null = 0.01;

  public typeRef: BatteryTypeRef | null = null;
  public isGridForming: boolean | null = null;
  public cRate: number | null = null;

  public chargeEfficiencyPercentage: number | null = null;
  public dischargeEfficiencyPercentage: number | null = null;

  public lifetimeCycles: number | null = null;
  public invertersLifetimeYear: number | null = 15;

  public fromHour: number | null = 0;
  public toHour: number | null = 24;

  constructor(options?: Partial<ScenarioBatteryExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): ScenarioBattery {
    return new ScenarioBattery({
      typeRef: this.typeRef,
      isGridForming: this.isGridForming,
      cRate: this.cRate,
      socMinPercentage: this.socMinPercentage,
      globalSocMaxPercentage: this.globalSocMaxPercentage,
      isRechargeableByGrid: this.isRechargeableByGrid,
      isRechargeableByGenerator: this.isRechargeableByGenerator,
      socMaxChargeGrid: this.socMaxChargeGrid,
      socMaxChargeGen: this.socMaxChargeGen,
      socToleranceGridForming: this.socToleranceGridForming,
      chargeEfficiencyPercentage: this.chargeEfficiencyPercentage,
      dischargeEfficiencyPercentage: this.dischargeEfficiencyPercentage,
      lifetimeCycles: this.lifetimeCycles,
      invertersLifetimeYear: this.invertersLifetimeYear,
      fromHour: this.fromHour,
      toHour: this.toHour
    });
  }
}
